import { render, staticRenderFns } from "./PhotoGrid.vue?vue&type=template&id=8de32cae&scoped=true"
import script from "./PhotoGrid.vue?vue&type=script&lang=js"
export * from "./PhotoGrid.vue?vue&type=script&lang=js"
import style0 from "./PhotoGrid.vue?vue&type=style&index=0&id=8de32cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de32cae",
  null
  
)

export default component.exports